export default {
  home: { path: '/', extra: { label: 'الصفحة الرئيسية' } },
  logout: '/logout',
  store: { path: '/store', extra: { label: 'المتجر' } },
  services: '/services/:id/:slug',
  fortuneTeller: '/fortune-teller/:id/:slug',
  buy: '/buy',
  // * [reserved] [add_new_route]
}
